<template>
  <div class="layout-wrapper">
    <Sidebar />

    <div class="content">
      <LoggedInHeader />
      <LoggedInHeaderMobile />

      <div class="mp-logged-in-content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    LoggedInHeaderMobile: () =>
      import("@/components/header/LoggedInHeaderMobile"),
    LoggedInHeader: () => import("@/components/header/LoggedInHeader"),
    Sidebar: () => import("@/components/sidebar/SideBar"),
  },
};
</script>

<style scoped lang="scss">
.layout-wrapper {
  min-height: 100vh;
  display: flex;
  flex-wrap: nowrap;
  flex-basis: 0;

  .content {
    flex-grow: 1;
    background: #f5f7fb;
  }

  .mp-logged-in-content {
    flex-grow: 1;
    overflow-x: auto;
    padding: 2rem;
  }
}
</style>
